/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_boardCarousel", {
        options: {
            slickOptions: {
                arrows: true,
                autoplay: false,
                autoplaySpeed: 4000,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
                appendArrows: jQuery(".s-board__actions__toolbar  .b-slick-arrows"),
            },
        },

        _create: function () {
            this.wrap = this.element;

            $(".s-board__carousel__items", this.wrap).each((indx, el) => {
                const hasTwoSlidesClass = $(el).hasClass("two-slides-visible");
                const slidesToShow = hasTwoSlidesClass ? 2 : 3;

                const slickOptions = {
                    ...this.options.slickOptions,
                    slidesToShow: slidesToShow,
                };

                $(el)
                    .on("init", (slick) => {
                        var dots = $(".slick-dots", $(slick.target));
                        api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed / 1000);
                    })
                    .slick(slickOptions)
                    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                        var dots = $(".slick-dots", $(event.target));
                        api.fn.slickDotsFilled(dots, nextSlide);
                    });
            });
        },
    });
})(jQuery);
